import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import HidePromoFSonFreespins from 'slotworks/commands/promo-free-spins/hide-pfs-on-freespins';
import Translations from 'slotworks/i18n/translations';
import State from 'slotworks/state-machine/states/state';
import regulation from 'slotworks/integration/revolver/regulations/regulation';
import Components from 'slotworks/components/components';
import betModel from 'slotworks/model/bets/bet-model';

export default class RecoverTreasureBonus extends State {
    public onEnter() {
        let contents = new Map<string, string>();
        contents.set('body', Translations.get('rec.fre'));
        HidePromoFSonFreespins();
        bonusBuyComponent.setEnabled(false);
        regulation.interactionStart();
        Components.betBar.setBetOptions(betModel.generateBetOptions());
        this.complete();
    }
}



// WEBPACK FOOTER //
// ./src/states/recover-treasure-bonus.ts